var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.905,
    height: 31.905,
    viewBox: "0 0 31.905 31.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add-2",
    d: "M29.056,13.1H19.371a.57.57,0,0,1-.57-.57V2.849a2.849,2.849,0,1,0-5.7,0v9.685a.57.57,0,0,1-.57.57H2.849a2.849,2.849,0,1,0,0,5.7h9.685a.57.57,0,0,1,.57.57v9.685a2.849,2.849,0,1,0,5.7,0V19.371a.57.57,0,0,1,.57-.57h9.685a2.849,2.849,0,1,0,0-5.7Zm0,0",
    fill: "#0b77c2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd2);
export default __webpack_public_path__ + "static/media/add-2.1d9b89508acc8626284f8a2ac07d9c8a.svg";
export { ForwardRef as ReactComponent };